/**
 * API Endpoints
 * Centralized API endpoint definitions
 */

const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    LOGOUT: '/auth/logout',
    REFRESH_TOKEN: '/auth/refresh-token',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    VERIFY_EMAIL: '/auth/verify-email',
    ME: '/auth/me',
  },

  // Users
  USERS: {
    BASE: '/users',
    BY_ID: (id) => `/users/${id}`,
    PROGRESS: (id) => `/users/${id}/progress`,
    ACHIEVEMENTS: (id) => `/users/${id}/achievements`,
    SUBMISSIONS: (id) => `/users/${id}/submissions`,
  },

  // Courses
  COURSES: {
    BASE: '/courses',
    BY_ID: (id) => `/courses/${id}`,
    ENROLL: (id) => `/courses/${id}/enroll`,
    PROGRESS: (id) => `/courses/${id}/progress`,
  },

  // Lessons
  LESSONS: {
    BASE: '/lessons',
    BY_ID: (id) => `/lessons/${id}`,
    COMPLETE: (id) => `/lessons/${id}/complete`,
    PROGRESS: (id) => `/lessons/${id}/progress`,
  },

  // Challenges
  CHALLENGES: {
    BASE: '/challenges',
    BY_ID: (id) => `/challenges/${id}`,
    TEST_CASES: (id) => `/challenges/${id}/test-cases`,
    HINTS: (id) => `/challenges/${id}/hints`,
    SOLUTIONS: (id) => `/challenges/${id}/solutions`,
  },

  // Submissions
  SUBMISSIONS: {
    BASE: '/submissions',
    BY_ID: (id) => `/submissions/${id}`,
    BY_CHALLENGE: (challengeId) => `/submissions/challenge/${challengeId}`,
    RERUN: (id) => `/submissions/${id}/rerun`,
    FEEDBACK: (id) => `/submissions/${id}/feedback`,
  },
};

export default API_ENDPOINTS;

